import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Auth0Provider } from '@auth0/auth0-react';
import { BrowserRouter } from 'react-router-dom';
import IntercomBoot from './components/IntercomBoot';
import TokenProbe from "./components/TokenProbe";
import SessionGate from "./components/SessionGate";

// Sin esto, un login disparado en /docs/... termina en la home y se pierde el
// documento que el usuario quería abrir.
const onRedirectCallback = (appState) => {
  window.history.replaceState(
    {},
    document.title,
    appState?.returnTo || `${window.location.pathname}${window.location.search}`
  );
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Auth0Provider
    domain={process.env.REACT_APP_AUTH0_DOMAIN}
    clientId={process.env.REACT_APP_AUTH0_CLIENT_ID}
    authorizationParams={{ redirect_uri: window.location.origin }}
    onRedirectCallback={onRedirectCallback}
    useRefreshTokens
    useRefreshTokensFallback={false} 
    cacheLocation="localstorage"
  >
    {/* Sin sesión verificada no se monta nada: ni el portal ni Intercom */}
    <SessionGate>
      <React.StrictMode>
        <BrowserRouter>
          <TokenProbe />
          <App />
        </BrowserRouter>
      </React.StrictMode>
      <IntercomBoot />
    </SessionGate>
  </Auth0Provider>
);

reportWebVitals();
